// extracted by mini-css-extract-plugin
export default {"pulse":"Buttons_pulse__0PeBs","animate":"Buttons_animate__br4Hy"};